import React, { useMemo } from "react";
import { Form, Select } from "antd";

const { Option } = Select;

const itemStyles = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 6 },
    lg: { span: 5 },
    xl: { span: 5 },
    xxl: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 18 },
    lg: { span: 15 },
    xl: { span: 12 },
    xxl: { span: 12 },
  },
};
const CONTRACTSTORAGE = "Contract Storage";

const NotificationSelectElement = (props) => {
  const {
    control,
    errors,
    HMGData,
    ProjectData,
    Controller,
    setProjectData,
    GetDocsFromMydocsData,
    config,
    resetField,
    isLoadingHMGData,
    isLoadingGetDocsFromMydocsData,
    watch,
  } = props;

  // get hmg list related to contract storage
  const hmgList = useMemo(
    () =>
      HMGData?.filter((element) => {
        return Boolean(
          ProjectData?.find(
            (el) =>
              el?.solution === CONTRACTSTORAGE && el.hmg_id === element._id,
          ),
        );
      })
        ?.sort((a, b) => a.hmg_name.localeCompare(b.hmg_name))
        ?.map((el) => (
          <Option key={el._id} value={el.hmg_id}>
            {el.hmg_name}
          </Option>
        )),
    [ProjectData, HMGData],
  );
  const handleHMGChange = () => {
    setProjectData(undefined);
    resetField("notificationSchedules.project");
    resetField("notificationSchedules.autoId");
    resetField("notificationSchedules.schedules");
  };

  // get solution from selected HMG
  const hotelManagementGroupId = watch(
    "notificationSchedules.hotelManagementGroupId",
  );
  const projectList = useMemo(
    () =>
      ProjectData?.filter(
        (obj) =>
          obj.hmg_id === hotelManagementGroupId &&
          obj.solution === CONTRACTSTORAGE,
      )?.map((project) => (
        <Option key={project._id} value={project._id}>
          {project.project_name}
        </Option>
      )),
    [ProjectData, hotelManagementGroupId],
  );

  // get solution related data
  const handleProjectChange = (e) => {
    let projectData = [];

    if (e) {
      const result = ProjectData?.find((obj) => obj._id === e);

      projectData = {
        projectId: result?.project_id,
        entityId: result?.is_entityid,
      };
    }
    setProjectData(projectData);
    resetField("notificationSchedules.autoId");
    resetField("notificationSchedules.schedules");
  };

  const documentData = [];
  const ReportData = GetDocsFromMydocsData?.data;
  if (ReportData !== undefined) {
    ReportData.map((item) => {
      return item.metaData.forEach((element) => {
        if (element.key === config.typeMap.autoId) {
          documentData.push({
            chainId: item.chainId,
            autoId: element.value,
          });
        }
      });
    });
  }
  const AutoIDData = documentData
    ?.sort((a, b) => {
      return a.autoId.localeCompare(b.autoId);
    })
    ?.map((el) => {
      return (
        <Option key={el.chainId} value={el.chainId}>
          {el.autoId}
        </Option>
      );
    });

  return (
    <>
      <Form.Item
        {...itemStyles}
        label="Hotel Management Group"
        help={errors?.notificationSchedules?.hotelManagementGroupId?.message}
        required
        validateStatus={
          errors?.notificationSchedules?.hotelManagementGroupId ? "error" : ""
        }
      >
        <Controller
          control={control}
          name="notificationSchedules.hotelManagementGroupId"
          render={({ field: { onChange, value } }) => (
            <Select
              placeholder="Please Select Hotel Management Group "
              showSearch
              allowClear
              loading={isLoadingHMGData}
              filterOption={(input, option) => {
                return (
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                );
              }}
              style={{ width: "90%" }}
              onChange={(values) => {
                onChange(values);
                handleHMGChange(values);
              }}
              value={value}
            >
              {hmgList}
            </Select>
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="Project"
        help={errors?.notificationSchedules?.project?.message}
        required
        validateStatus={errors?.notificationSchedules?.project ? "error" : ""}
      >
        <Controller
          control={control}
          name="notificationSchedules.project"
          render={({ field: { onChange, value } }) => (
            <Select
              allowClear
              showSearch
              onChange={(e) => {
                onChange(e);
                handleProjectChange(e);
              }}
              style={{ width: "90%" }}
              loading={Array(projectList).length === 0}
              value={value}
              filterOption={(input, option) => {
                return (
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                );
              }}
              placeholder="Please Select Project"
            >
              {projectList}
            </Select>
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="Auto ID"
        help={errors?.notificationSchedules?.autoId?.message}
        required
        validateStatus={errors?.notificationSchedules?.autoId ? "error" : ""}
      >
        <Controller
          control={control}
          name="notificationSchedules.autoId"
          render={({ field: { onChange, value } }) => (
            <Select
              allowClear
              showSearch
              loading={isLoadingGetDocsFromMydocsData}
              onChange={(e) => {
                onChange(e);
              }}
              style={{ width: "90%" }}
              value={value}
              filterOption={(input, option) => {
                return (
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                );
              }}
              placeholder="Please Select Auto ID "
            >
              {AutoIDData}
            </Select>
          )}
        />
      </Form.Item>
    </>
  );
};

export default NotificationSelectElement;
